import Vue from 'vue'
import vSelect from 'vue-select'

import Datepicker from 'vuejs-datepicker'
import { it } from 'vuejs-datepicker/dist/locale'

Vue.component('v-select', vSelect)
Vue.component('v-typeahead', {
  extends: vSelect,
  props: {
    clearable: {
      type: Boolean,
      default: () => true
    },
    taggable: {
      type: Boolean,
      default: () => true
    },
    pushTags: {
      type: Boolean,
      default: () => true
    },
    components: {
      type: Object,
      default: () => ({
        OpenIndicator: {
          render: build => build('fa-icon', { class: 'has-text-grey',props: { icon: ['fas', 'magic']}}),
        }
      })
    },
  }
})

Vue.component('date-picker', {
  extends: Datepicker,
  props: {
    language: {
      type: Object,
      default: () => it
    },
    format: {
      type: String,
      default: () => 'dd/MM/yyyy'
    },
    mondayFirst: {
      type: Boolean,
      default: () => true
    },
    fullMonthName: {
      type: Boolean,
      default: () => true
    },
    inputClass: {
      type: String,
      default: () => 'input datepicker'
    },
    openDate: {
      type: Date,
      default: () => new Date()
    },
    wrapperClass: {
      type: String,
      default: () => 'control'
    }
  } 
})